import { AbstractControl, ValidatorFn, Validators } from "@angular/forms";
import { AppRegex } from "../constants/app-regex";
import { DataType } from "../enums/data-type.enum";

export class CustomValidator {
  private static regex = new RegExp(AppRegex.PasswordRegex);
  static onlyNumbersValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      // Regular expression to check if the input contains only digits
      const numberRegex = /^\d+$/;

      if (
        control.value === undefined ||
        control.value == null ||
        control.value === ""
      ) {
        // If the control is empty, return null (valid)
        return null;
      }

      // Test the control value against the regex
      const valid = numberRegex.test(control.value);
      return valid ? null : { onlyNumbers: true };
    };
  }

  static ipAddressValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      // Regular expression for matching a valid IPv4 address
      const ipRegex =
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

      if (
        control.value === undefined ||
        control.value == null ||
        control.value === ""
      ) {
        // If the control is empty or undefined, return null (valid)
        return null;
      }
      // Test the control value against the regex
      const valid = ipRegex.test(control.value);
      return valid ? null : { ipAddress: true };
    };
  }
  static emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value === undefined || control.value == null) {
        return { email: true };
      }
      return null;
    };
  }

  static swiftCodeValidator(min: number, max: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value === undefined || control.value == null) {
        return { swiftCode: true };
      }
      if (control.value.length !== min && control.value.length !== max) {
        return { swiftCode: true };
      }
      return null;
    };
  }

  static PasswordMatch(passwordControl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value === undefined || control.value == null) {
        return { match: true };
      }
      if (control.value !== passwordControl.value) {
        return { match: true };
      }
      return null;
    };
  }

  static Password(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value) {
        // if control is empty return no error
        return null;
      }
      // test the value of the control against the regexp supplied
      const valid = this.regex.test(control.value);
      // if true, return no error (no error), else return error passed in the second parameter
      return valid ? null : { password: true };
    };
    // const result = Validators.pattern(AppRegex.PasswordRegex);
    // return result.length ? null : { 'password': true };
  }

  static GreaterThan(
    minControl: AbstractControl,
    type: DataType = DataType.Number,
  ): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (minControl == null || control == null) {
        return null;
      }
      if (type === DataType.Number) {
        if (+control.value <= +minControl.value) {
          return { greater: true, value: minControl.value };
        }
      }
      if (type === DataType.Date) {
        if (control.value <= minControl.value) {
          return { greater: true, value: minControl.value };
        }
      }

      return null;
    };
  }

  static LessThan(
    maxControl: AbstractControl,
    type: DataType = DataType.Number,
  ): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (maxControl == null || control == null) {
        return null;
      }
      if (type === DataType.Number) {
        if (+control.value > +maxControl.value) {
          return { less: true, value: maxControl.value };
        }
      }
      if (type === DataType.Date) {
        if (control.value > maxControl.value) {
          return { less: true, value: maxControl.value };
        }
      }

      return null;
    };
  }

  static NoUnderScore(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value === undefined || control.value == null) {
        return { underscore: true };
      }
      if (control.value.toString().includes("_")) {
        return { underscore: true };
      }
      return null;
    };
  }

  static Phone(optional: boolean = false): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (!control.value) {
        return null;
      }
      const value = control.value.toString().trim();
      if (value.length === 0 && optional) {
        return null;
      }
      if (!(value.startsWith("+") && value.length > 10 && value.length <= 15)) {
        return { phone: true };
      }
      return null;
    };
  }

  static PhoneExt(optional: boolean = false): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (!control.value) {
        return null;
      }
      const value = control.value.toString().trim();
      if (value.length === 0 && optional) {
        return null;
      }
      if (!(value.startsWith("+") && value.length > 1 && value.length <= 4)) {
        return { phoneExt: true };
      }
      return null;
    };
  }
}
